module.exports = __webpack_public_path__ + "static/media/font_regular.45a6c1e3.woff";